import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class AuthService {
  async login(loginId, password, code = "") {
    return (
      await fetchApi.post(`/user/login`, {
        loginId,
        password,
        code,
      })
    ).data;
  }

  async logout() {
    return (await fetchApi.get(`/user/logout`)).data;
  }

  async getAuthUser() {
    return (await fetchApi.get(`/user/getAuthUser`)).data;
  }

  async getIDPListForAuth() {
    return (await fetchApi.get(`/authProvider/auth/list`)).data;
  }
}
